import React from 'react'
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Box, Grid} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import {useTranslation} from "react-i18next";
import {getCurrentLanguage} from "../utils/Helpers";

const tree_species = require("../data/tree_species.json")
const ColoredTableCell = ({value}: any) => {
    const colors = {
        "green": "#00ff00",
        "yellow": "#FFD700",
        "red": "#D97557",
        "grey": "#B0B0B0"
    }
    let backgroundColor = colors.grey;
    if (value >= 3) {
        backgroundColor = colors.green;
    } else if (value >= 2 && value < 3) {
        backgroundColor = colors.yellow;
    } else if (value < 2) {
        backgroundColor = colors.red;
    }

    return (
        <TableCell
            align="center"
            sx={{
                border: "1px solid",
                backgroundColor: backgroundColor
            }}>{value.toString().replace(".", ",")}</TableCell>
    )
}

interface FilledRectangleProps {
    color: string; // Hex color code
    text: string; // Text to display
}

const FilledRectangle: React.FC<FilledRectangleProps> = ({color, text}) => {
    return (
        <svg width="250" height="50">
            <rect x="10" y="10" width="50" height="30" fill={color}/>
            <text x="75" y="30" fill="black">{text}</text>
        </svg>
    );
}

const TreeTypeTable = () => {
    const {t, i18n} = useTranslation()
    let key = getCurrentLanguage(i18n);
    let data = tree_species[key].sort((a: any, b: any) => a.scientific_name > b.scientific_name ? 1 : -1);

    return (
        <Grid container>
            <Grid container>
                <Grid item xs={4}>
                    <FilledRectangle color="#00ff00" text={t('tree_types_table.high_tolerance' as any)}/>
                </Grid>
                <Grid item xs={4}>
                    <FilledRectangle color="#FFD700" text={t('tree_types_table.medium_tolerance' as any)}/>
                </Grid>
                <Grid item xs={4}>
                    <FilledRectangle color="#D97557" text={t('tree_types_table.low_tolerance' as any)}/>
                </Grid>
            </Grid>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{border: "1px solid"}}>
                        <TableRow>
                            <TableCell sx={{borderBottomColor: "white", "& fieldset": {border: 'none'}}}
                                       align="center"></TableCell>
                            <TableCell colSpan={2} sx={{
                                borderLeft: "1px solid",
                                borderRight: "1px solid",
                                borderBottomColor: "white"
                            }}
                                       align="center">{t('tree_types_table.tree_specie' as any)}</TableCell>
                            <TableCell sx={{borderBottomColor: "white"}} align="center">{t('tree_types_table.origin' as any)}</TableCell>
                            <TableCell colSpan={3} sx={{border: "1px solid"}}
                                       align="center">{t('tree_types_table.tolerance_against' as any)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{borderLeft: "1px solid", borderBottom: "1px solid"}}
                                       align="center"></TableCell>
                            <TableCell sx={{borderLeft: "1px solid", borderBottom: "1px solid"}}
                                       align="center"></TableCell>
                            <TableCell sx={{borderBottom: "1px solid"}} align="center"></TableCell>
                            <TableCell sx={{border: "1px solid"}} align="center"></TableCell>
                            <TableCell sx={{border: "1px solid"}} align="center">{t('tree_types_table.shading' as any)}</TableCell>
                            <TableCell sx={{border: "1px solid"}} align="center">{t('tree_types_table.dryness' as any)}</TableCell>
                            <TableCell sx={{border: "1px solid"}} align="center">{t('tree_types_table.water_logging' as any)}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data.map((row: any) =>
                                <TableRow>
                                    <TableCell sx={{
                                        border: "1px solid",
                                        fontWeight: row.calculation === "true" ? 'bold' : 'normal',
                                        backgroundColor: row.calculation === "true" ? "#b6e1f6" : "#ffffff"
                                    }} align="center">
                                        <Box
                                            component="img"
                                            sx={{
                                                height: 100,
                                                width: 150,
                                                maxHeight: {xs: 233, md: 167},
                                                maxWidth: {xs: 350, md: 250},
                                            }}
                                            alt="Tree Species"
                                            src={require("../assets/species/" + row.picture)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{
                                        border: "1px solid",
                                        fontWeight: row.calculation === "true" ? 'bold' : 'normal',
                                        backgroundColor: row.calculation === "true" ? "#b6e1f6" : "#ffffff"
                                    }} align="center">
                                        {row.name}
                                    </TableCell>
                                    <TableCell sx={{
                                        border: "1px solid",
                                        fontWeight: row.calculation === "true" ? 'bold' : 'normal',
                                        backgroundColor: row.calculation === "true" ? "#b6e1f6" : "#ffffff"
                                    }} align="center">
                                        {row["scientific_name"]}
                                    </TableCell>
                                    <TableCell sx={{
                                        border: "1px solid",
                                        fontWeight: row.calculation === "true" ? 'bold' : 'normal',
                                        backgroundColor: row.calculation === "true" ? "#b6e1f6" : "#ffffff"
                                    }} align="center">
                                        {row["origin"]}
                                    </TableCell>
                                    <ColoredTableCell value={row.light}/>
                                    <ColoredTableCell value={row["drought"]}/>
                                    <ColoredTableCell value={row["water"]}/>
                                </TableRow>
                            )
                        }

                    </TableBody>
                </Table>
            </TableContainer>
            {/*<Grid container justifyContent="flex-end">*/}
            {/*    <Typography sx={{fontStyle: "italic"}} paragraph>Quellen: Herkunft: Roloff 2013, Toleranzen: Niinemets*/}
            {/*        und Valladares 2006, Bilder: baumportal.de</Typography>*/}
            {/*</Grid>*/}
        </Grid>

    )


}
export default TreeTypeTable
